import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetCustomersGroupsChartData = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const Api = useApi()

  const initialFilters = {
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
  }

  const {filters, onDateChange} = useFilters(initialFilters)

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/customer-groups', {
    queryId: 'profitability-list-customer-groups-chart',
    filters: filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  return {
    CustomersGroupsData: response?.data || [],
    onDateChangeCustomersGroupsChart: onDateChange,
    isLoading: isFetching,
  }
}

export default useGetCustomersGroupsChartData
